<template>
  <modal width="35" title="Process Handoff" :show-modal="showModal" @close-modal="$emit('close-modal')">
    <div class="flex my-4 flex-col gap-2 justify-center">
      <div class="head-wrap">
        <div class="">
          <h2 class="font-normal">Shipping Ref:</h2>
          <p class="font-semibold">{{ booking && booking.reference ? booking.reference : 'N/A' }}</p>
        </div>
        <div class="">
          <h2 class="font-normal">Booking Date:</h2>
          <p class="font-semibold">
            <!-- {{ booking && booking.createdAt ? booking.createdAt.split("T")[0] : 'N/A' }}  -->
            {{ booking.createdAt ? booking.createdAt.split("T")[0] : "N/A" }}
          </p>
        </div>
        <div class="">
          <h2 class="font-normal">Delivery Date:</h2>
          <p class="font-semibold">{{ booking && booking.deliveryDate ? booking.deliveryDate : 'N/A' }}</p>
        </div>
      </div>
      <div class="flex flex-col gap-2 w-100">
        <div class="font-semibold">3PL Company:</div>
        <div>
          <input class="input" disabled
            :value="booking && booking.receivingShippingService && booking.receivingShippingService.orgName ? booking.receivingShippingService.orgName : 'N/A'" />
        </div>
      </div>
      <div class="flex flex-col gap-2 w-100">
        <div class="font-semibold">Terminal:</div>
        <div>
          <input class="input" disabled
            :value="terminalUsers && terminalUsers.terminal && terminalUsers.terminal.name ? terminalUsers.terminal.name : 'N/A'" />
        </div>
      </div>

      <!--<div class="flex flex-col gap-2 w-100">
        <div class="font-semibold">Booking Date:</div>
        <div>
          <el-date-picker disabled type="date" placeholder="Start Date" style="margin: 0" class="mr-3"
            v-model="booking.createdAt" />
        </div>
      </div>

      <div class="flex flex-col gap-2 w-full">
        <div class="font-semibold">Delivery Date:</div>
        <div>
          <el-date-picker disabled type="date" placeholder="Delivery Date" style="margin: 0" class="mr-3"
            v-model="deliveryDate" />
        </div>
      </div>
      <hr class="my-2" />
      <p class="font-bold">Handoff process for:</p>
      <div class="flex flex-col gap-2 w-100">
        <div class="font-semibold">3pl Company:</div>
        <div>
          <el-select filterable v-model="toOrgId" placeholder="3pl Company">
            <el-option v-for="kind in organizations" :key="kind.id" :label="kind.companyname" :value="kind.id">
            </el-option>
          </el-select>
        </div>
      </div> -->

      <div class="flex flex-col gap-2 w-100">
        <div class="font-semibold">3pl User:</div>
        <div>
          <!-- <el-select filterable @change="getUserObj" v-model="toUserId" placeholder="Individual/Organization"> -->
          <el-select filterable v-model="toUserId" placeholder="Individual/Organization">
            <el-option v-for="user in terminalUsers.users" :key="user.id" :label="`${user.firstname} ${user.lastname}`"
              :value="user.id"></el-option>
          </el-select>
          
          <!-- <span class="text-xs text-blue-500">{{user.fleets.vehicleType}}-{{user.fleets.plateNumber}}</span> |
          <span class="text-xs text-blue-500">{{user.mobile_no}}</span>  -->
        </div>
      </div>
      <div class="flex flex-col gap-2 w-100">
        <div class="font-semibold">Delivery Status</div>
        <div>
          <el-select filterable  v-model="packageStatus" placeholder="--select--">
            <el-option v-for="(status,  index) in statusList" :key="index" :label="status"
              :value="status">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="flex flex-col gap-2 w-100">
        <div class="font-semibold">Upload Documents</div>
        <div>
          <el-select filterable @change="getUserObj" v-model="toUserId" placeholder="Individual/Organization">
            <el-option v-for="kind in users" :key="kind.id" :label="kind.firstname + ' ' + kind.lastname"
              :value="kind.id"></el-option>
          </el-select>
        </div>
      </div>

      <div class="flex justify-end w-100">
        <base-button text="Request Handoff Receipt" @click="
          $emit('show-confirm-handoff', processObj);
        $emit('close-modal');
        " :loading="loading" />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  components: {},
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    booking: {
      type: Object,
      required: true,
    },
    terminalUsers: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // reason: "",
      // loading: false,
      // organizations: [],
      // users: [],
      toUserId: "",
      packageStatus: "",
      statusList: [
        "Good Condition",
        "Damaged Condition"
      ],
      // toOrgId: "",
      // userObj: {},
      // locationObj: {},
      // orgReceiver: {},
      deliveryDate: new Date(),
    };
  },
  watch: {
    // toOrgId(val) {
    //   this.getAllUsers(val);
    // },
  },
  computed: {
    // orgid() {
    //   return this.$store.state.authentication.quantumOrganizationId;
    // },
    // userid() {
    //   return this.$store.state.authentication.quantumUserId;
    // },
    // processObj() {
    //   return {
    //     fromOrgid: this.$store.state.authentication.organizationId,
    //     toOrgId: this.toOrgId,
    //     fromUserId: this.$store.state.authentication.userId,
    //     toUserId: this.toUserId,
    //     booking: this.booking,
    //     userObj: this.userObj,
    //     locationObj: this.locationObj,
    //     orgReceiver: this.orgReceiver,
    //   };
    // },
        processObj() {
      return {
        orgId: this.booking.orgId,
        handoffType: "single",
        shippingId: this.booking.shipingId,
        receiver: this.booking.receiver,
        receivingShippingService: this.booking.receivingShippingService,
        sendingShippingServiceId: this.booking.sendingShippingServiceId, 
        receivingShippingServiceId: this.booking.receivingShippingServiceId,
        receivingUserId: null,
        fleetId: null,
        driverId: null,
        deliveryStatus: this.packageStatus,
        initiatedBy: null
      };
    },
  },
  methods: {
    // getAllUsers(orgid) {
    //   try {
    //     let users = this.organizations.find((x) => x.id == orgid).users;

    //     this.users = users;
    //     this.loading = false;
    //     localStorage.setItem("users", JSON.stringify(this.users));
    //   } catch (error) {
    //     this.handleError(error);
    //     this.loading = false;
    //   }
    // },
    // async getOrganizations() {
    //   try {
    //     this.loading = true;
    //     const response = await this.$_organizations();
    //     let organizations = response.data.data;

    //     this.organizations = organizations.filter(
    //       (x) => x.id != this.$store.state.authentication.organizationId
    //     );

    //     this.loading = false;
    //     this.$emit("booking-subaction-completed");

    //     this.closeModal();
    //   } catch (error) {
    //     this.loading = false;
    //     this.handleError(error);
    //     this.loading = false;
    //   }
    // },
    // getUserObj() {
    //   let userObj = this.users.find((x) => (x.id = this.toUserId));
    //   let orgReciever = this.organizations.find((x) => x.id == this.toOrgId);
    //   let locationObj = this.organizations
    //     .find((x) => x.id == this.toOrgId)
    //     .locations.find((x) => x.locationManager == this.toUserId);

    //   this.orgReceiver = {
    //     companyname: orgReciever.companyname,
    //     mobile_no: orgReciever.mobile_no,
    //   };

    //   this.userObj = {
    //     firstname: userObj.firstname,
    //     lastname: userObj.lastname,
    //     mobile_no: userObj.mobile_no,
    //     email: userObj.email,
    //   };

    //   this.locationObj = {
    //     locationName: locationObj.locationName,
    //     address: locationObj.address,
    //     state: locationObj.state,
    //     country: locationObj.country,
    //   };
    // },

    closeModal() {
      this.$emit("close-modal");
    },
  },
  mounted() {
    // this.getOrganizations();
    // this.getAllUsers();
  },
};
</script>

<style scoped>
.head-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* font-size: 1.2rem; */
  /* font-weight: bold; */
}

.delete-modal {
  text-align: center;
}
</style>
